import { render, staticRenderFns } from "./OptionLieferart.vue?vue&type=template&id=f3e06b8c&"
import script from "./OptionLieferart.vue?vue&type=script&lang=js&"
export * from "./OptionLieferart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports